import container from './container';

export default container;



// WEBPACK FOOTER //
// ./src/components/App/index.js